import { InjectionToken } from '@angular/core';
import { ConfirmationPort } from '../ports/confirmation.port';

export const CONFIRMATION_SERVICE = new InjectionToken<ConfirmationPort>('ConfirmationService');